module.exports = __webpack_public_path__ + "static/cashew_nuts_nong_cu_2-1c041a158a264d00d2a7b66c218b6524.jpg";